module.exports = __webpack_public_path__ + "img/265.clean_shop_floor.1b4f7a15.svg";